import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

export default function InteractiveSimulationLayout({ children }) {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Layout
        className="site-layout"
        style={{ background: 'white', overflowY: 'auto' }}
      >
        <Content style={{ margin: '0px', background: 'white' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
